export default {
  props: {
    config: {},
    model: {}
  },
  data () {
    return {
      form: this.normalizedModel(this.model)
    }
  },
  watch: {
    model (val) {
      this.form = this.normalizedModel(val)
    }
  },
  computed: {
    showAddItem () {
      return this.config.maxItemsCount === 0 || this.config.maxItemsCount > this.form.leftItems.length
    }
  },
  methods: {
    normalizedModel (model) {
      let val = Object.assign({leftItems: [], rightItems: []}, model)
      let count = Math.max(this.config.minItemsCount, 1)
      if (val.leftItems.length < count) {
        val.leftItems = val.leftItems.concat(Array(Math.max(count - val.leftItems.length, 1)).fill().map(() => {
          return {}
        }))
        val.rightItems = val.rightItems.concat(Array(Math.max(count - val.rightItems.length, 1)).fill().map(() => {
          return {}
        }))
      }
      //处理异常数据结构
      val.leftItems = val.leftItems.map(n => {
        return Array.isArray(n) ? {} : n
      })
      val.rightItems = val.rightItems.map(n => {
        return Array.isArray(n) ? {} : n
      })
      return val
    },
    getItems () {
      return this.model.leftItems.filter(n => n.text)
    },
    addItem (index) {
      this.form.leftItems.splice(index + 1, 0, {})
      this.form.rightItems.splice(index + 1, 0, {})
    },
    removeItem (index) {
      if (this.form.leftItems.length > 1 && this.config.minItemsCount < this.form.leftItems.length) {
        this.form.leftItems.splice(index, 1)
        this.form.rightItems.splice(index, 1)
      } else {
        this.form.leftItems.splice(index, 1, {})
        this.form.rightItems.splice(index, 1, {})
      }
    }
  }
}
